import { useEffect, useState } from 'react';
import {
    Box,
    Chip,
    FormControlLabel,
    Switch,
    Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useUserProfileQuery } from 'app/store';
import TwoVeifyDialog from './two-verify.dialog';

export const TwoVeify = (): JSX.Element => {
    const [open, setOpen] = useState(false);
    const { data: profile } = useUserProfileQuery();
    const isActive = !!profile?.twoverify;

    useEffect(() => {
        if (!profile) setOpen(false);
    }, [profile]);

    return (
        <>
            <Box
                sx={(theme) => ({
                    position: 'relative',
                    overflow: 'hidden',
                    p: { xs: 2.25, md: 3 },
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: isActive
                        ? alpha(theme.palette.success.main, 0.28)
                        : 'divider',
                    bgcolor: isActive
                        ? alpha(theme.palette.success.main, 0.035)
                        : 'background.paper',
                })}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2.5,
                    }}
                >
                    <Box
                        sx={{
                            minWidth: 0,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={(theme) => ({
                                width: 48,
                                height: 48,
                                flexShrink: 0,
                                borderRadius: 2.25,
                                display: 'grid',
                                placeItems: 'center',
                                bgcolor: alpha(
                                    isActive
                                        ? theme.palette.success.main
                                        : theme.palette.primary.main,
                                    0.1,
                                ),
                                color: isActive
                                    ? 'success.main'
                                    : 'primary.main',
                                '& i': { fontSize: 21 },
                            })}
                        >
                            <i className="fa-light fa-shield-halved" />
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    className="font-yekan-heavy"
                                    sx={{ fontSize: { xs: 15, md: 17 } }}
                                >
                                    تایید دومرحله‌ای
                                </Typography>
                                <Chip
                                    size="small"
                                    color={isActive ? 'success' : 'default'}
                                    variant={isActive ? 'filled' : 'outlined'}
                                    label={isActive ? 'فعال' : 'غیرفعال'}
                                    sx={{ height: 24, fontSize: 11 }}
                                />
                            </Box>

                            <Typography
                                variant="body2"
                                sx={{
                                    mt: 0.75,
                                    color: 'text.secondary',
                                    lineHeight: 2,
                                    maxWidth: 650,
                                }}
                            >
                                برای ورود به حساب، علاوه بر کد پیامکی باید رمز عبور
                                دومرحله‌ای اختصاصی خود را نیز وارد کنید.
                            </Typography>
                        </Box>
                    </Box>

                    <FormControlLabel
                        sx={{
                            m: 0,
                            flexShrink: 0,
                            px: 1.25,
                            py: 0.5,
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            bgcolor: 'background.default',
                            '.MuiFormControlLabel-label': {
                                fontSize: 13,
                                whiteSpace: 'nowrap',
                            },
                        }}
                        control={
                            <Switch
                                checked={isActive}
                                onChange={() => setOpen(true)}
                            />
                        }
                        label={isActive ? 'فعال است' : 'غیرفعال است'}
                    />
                </Box>
            </Box>

            <TwoVeifyDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
